<template>
    <div class="p-col-12">
          <!-- Filtros -->
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="dataInicio">Data Início</label>
              <Calendar 
                showButtonBar 
                id="dataInicio" 
                v-model="filtros.dataInicio" 
                dateFormat="dd/mm/yy"
                :showIcon="true"
              />
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="dataFim">Data Fim</label>
              <Calendar 
                showButtonBar 
                id="dataFim" 
                v-model="filtros.dataFim" 
                dateFormat="dd/mm/yy"
                :showIcon="true"
              />
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="status">Conta Principal</label>
              <Dropdown 
                id="status" 
                v-model="filtros.contaPrincipal" 
                :options="contasOptions" 
                optionLabel="nome" 
                optionValue="id"
                placeholder="Selecione...."
              />
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="status">Status</label>
              <Dropdown 
                id="status" 
                v-model="filtros.status" 
                :options="statusOptions" 
                optionLabel="nome" 
                optionValue="id"
                placeholder="Selecione...."
              />
            </div>

            <div class="p-field p-col-12 p-md-3">
              <label for="seguimento">Segmento</label>
              <Dropdown 
                id="seguimento" 
                v-model="filtros.seguimento" 
                :options="seguimentoOptions" 
                optionLabel="nome" 
                optionValue="id"
                placeholder="Selecione...."
              />
            </div>

            <div class="p-field p-col-12 p-md-3">
              <label for="revendedor">Revendedor</label>
              <Dropdown 
                id="revendedor" 
                v-model="filtros.revendedorId" 
                :options="revendedorOptions" 
                optionLabel="nome" 
                optionValue="id"
                placeholder="Selecione...."
                :filter="true"
              />
            </div>

            <div class="p-field p-col-12 p-md-3">
              <label for="plano">Plano</label>
              <Dropdown 
                id="plano" 
                v-model="filtros.nomePlano" 
                :options="planoOptions" 
                optionLabel="nome" 
                optionValue="id"
                placeholder="Selecione...."
              />
            </div>

            <div class="p-field p-col-0 p-d-flex p-ai-end">
              <Button 
                label="Buscar" 
                icon="pi pi-search" 
                class="p-mr-2"
                @click="buscar"
              />              
            </div>
          </div>

          <!-- Tabela -->
          <div class="p-mt-4">
            <DataTable 
              :value="clientes" 
              responsiveLayout="scroll"
              class="p-datatable-sm"
            >
              <template #header>
                <div class="p-d-flex p-jc-left p-ai-center">                 
                  <Button 
                    label="Exportar Excel (Geral)" 
                    icon="pi pi-file-excel" 
                    class="p-button-success p-button-sm p-mr-2"
                    @click="exibirConfirmarExportaCSV('GERAL')"
                  />
                  <Button 
                    label="Exportar Excel (Último Acesso)" 
                    icon="pi pi-file-excel" 
                    class="p-button-success p-button-sm"
                    @click="exibirConfirmarExportaCSV('ULTIMO_ACESSO')"
                  />
                </div>
              </template>

              <Column field="cnpj" header="CNPJ">
                <template #body="slotProps">
                  {{ formatarCNPJ(slotProps.data.numero) }}
                </template>
              </Column>

              <Column field="razaoSocial" header="Razão Social"></Column>

              <Column field="dataCadastro" header="Data Cadastro">
                <template #body="slotProps">
                  {{ formatarData(slotProps.data.dataCadastroEmpresa) }}
                </template>
              </Column>

              <Column field="dataContrato" header="Data Contrato">
                <template #body="slotProps">
                  {{ formatarData(slotProps.data.dataContratoCliente) }}
                </template>
              </Column>

              <Column field="status" header="Status">
                <template #body="slotProps">
                  <label>{{ getStatus(slotProps.data.statusEmpresa) }}</label>
                </template>
              </Column>

              <Column field="planoNome" header="Plano" />

              <Column field="principal" header="Principal">
                <template #body="slotProps">
                  <label>{{ slotProps.data.principal ? 'Sim' : 'Não' }}</label>
                </template>
              </Column>

              <Column field="ultimoAcesso" header="Último Acesso">
                <template #body="slotProps">
                  {{ formatarDataHora(slotProps.data.ultimoAcesso) }}
                </template>
              </Column>
            </DataTable>

            <!-- Paginação -->
            <Paginator 
              v-model="paginacao.pagina"
              :rows="paginacao.linhas" 
              :totalRecords="paginacao.totalLinhas"
              :rowsPerPageOptions="[10, 15, 20, 30]"
              @page="paginar($event)"
              class="p-mt-3"
            />
          </div>

          <Dialog :visible.sync="exibirDialogConfirmarCsv" header="E-mail Arquivo CSV" :modal="true" :style="{width: '450px'}">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                  <label>E-mail</label>
                  <InputText v-model.trim="emailCSV"/>
                </div>
            </div>
            <template #footer>
              <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarCsv=false"/>
              <Button label="Gerar CSV" icon="pi pi-check" class="p-button-primary" @click="exportarCsv('GERAL')" />
            </template>
          </Dialog>

          <Dialog :visible.sync="exibirDialogConfirmarCsvUltimoAcesso" header="E-mail Arquivo CSV" :modal="true" :style="{width: '450px'}">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                  <label>E-mail</label>
                  <InputText v-model.trim="emailCSV"/>
                </div>
                <div class="p-field p-col-12">
                  <label>Dias sem Acesso</label>
                  <InputNumber id="quantidadePessoas" v-model.number="diasSemAcesso" :useGrouping="false" autocomplete="off" maxlength="2"/>
                </div>
            </div>
            <template #footer>
              <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarCsvUltimoAcesso=false"/>
              <Button label="Gerar CSV" icon="pi pi-check" class="p-button-primary" @click="exportarCsv('ULTIMO_ACESSO')" />
            </template>
          </Dialog>
    </div>
</template>

<script>
import EmpresaService from '../../../service/EmpresaService';
import { exibirMensagem, exibirMensagemSis } from '@/global';

export default {
  empresaService: null,
  data() {
    return {
      exibirDialogConfirmarCsvUltimoAcesso: false,
      exibirDialogConfirmarCsv: false,
      emailCSV: '',
      diasSemAcesso: 15,
      filtros: {
        dataInicio: null,
        dataFim: null,
        status: null,
        seguimento: null,
        revendedorId: null,
        nomePlano: null,
        contaPrincipal: null,
        cnpjPrincipal: false,        
      },  
      contasOptions: [{id: '', nome: 'Selecione...'}, {id: 'SIM', nome: 'Sim'}, {id: 'NAO', nome: 'Não'}],
      seguimentoOptions: [
        { id: '', nome: 'Selecione...' },
        { id: 'Bares e restaurantes', nome: 'Bares e restaurantes' },
        { id: 'Construção civil', nome: 'Construção civil' },
        { id: 'Condomínios e Hostéis', nome: 'Condomínios e Hostéis' },
        { id: 'Grandes empresas e órgãos públicos', nome: 'Grandes empresas e órgãos públicos' },
        { id: 'Instituições de ensino', nome: 'Instituições de ensino' },
        { id: 'Pequenas e médias empresas', nome: 'Pequenas e médias empresas' },
        { id: 'Saúde', nome: 'Saúde' },
        { id: 'Varejo', nome: 'Varejo' },
        { id: 'Outros', nome: 'Outros' }
      ],
      statusOptions: [],
      revendedorOptions: [],
      planoOptions: [],
      clientes: [],
      paginacao: {
        pagina: 0,
        linhas: 10,
        totalLinhas: 0
      }
    };
  },  
  methods: {
    /**
     * 
     */
    buscar() {       
      this.paginacao.pagina = 0; 
      this.listarClientes(this.getFiltros());
    },
    /**
     * 
     */
    listarFiltros() {
      this.empresaService.listarFiltros()
			.then(resp => {	
        const filtros = resp.data;
        this.planoOptions = filtros.planos;
        this.planoOptions.splice(0, 0, {id:'', nome: 'Selecione....'});
        this.revendedorOptions = filtros.revendedores;
        this.revendedorOptions.splice(0, 0, {id:'', nome: 'Selecione....'});
        this.statusOptions = filtros.status;
        this.statusOptions.splice(0, 0, {id:'', nome: 'Selecione....'});
        
			})
			.catch(erro => {exibirMensagem(this, erro)});
    },
    /**
     * 
     */
    listarClientes(filtros) {          
      this.empresaService.listarClientes(filtros)
			.then(resp => {	
        this.clientes = resp.data.clientes;
        this.paginacao.totalLinhas = resp.data.total;
			})
			.catch(erro => {exibirMensagem(this, erro)});
    },
    /**
     * 
     */
    paginar(event) {
      const filtros = this.getFiltros();
      this.paginacao.pagina = event.page;
      filtros.pagina = event.page;
      this.listarClientes(this.getFiltros());
    },
    /**
     * 
     */
    getFiltros() {
      let cnpjPrincipal = null;
      if(this.filtros.contaPrincipal == 'SIM') {
        cnpjPrincipal = true;
      } else if(this.filtros.contaPrincipal == 'NAO') {
        cnpjPrincipal = false;
      }
      return  {
        dataInicio: this.formatarDataAPI(this.filtros.dataInicio),
        dataFim: this.formatarDataAPI(this.filtros.dataFim),
        status: (this.filtros.status ? this.filtros.status : null),
        seguimento: this.filtros.seguimento,
        revendedorId: (this.filtros.revendedorId ? this.filtros.revendedorId : null),
        nomePlano: this.filtros.nomePlano,
        cnpjPrincipal: cnpjPrincipal,
        pagina: this.paginacao.pagina,
        totalPorPagina: this.paginacao.linhas
      }
    },
    /**
     * 
     */
    exportarCsv(tipo) {
      if(!this.emailCSV) {
        exibirMensagemSis(this, 'Informe um E-mail', true);  
        return;
      }
      if('ULTIMO_ACESSO' == tipo && this.diasSemAcesso <= 0) {
        exibirMensagemSis(this, 'Informe dias sem acesso com um valor maior que 0', true);  
        return;
      }  
      let request = this.getFiltros();
      if('ULTIMO_ACESSO' == tipo) {
        request = {
          diasSemAcesso: this.diasSemAcesso
        }
      }          
      request['emailArquivoCSV'] = this.emailCSV;
      sessionStorage.setItem('EMAIL_CSV_EXPORTAR_CLIENTE', this.emailCSV);
      this.empresaService.exportarCsv(request, tipo)
			.then(() => {	
         exibirMensagemSis(this, 'Sucesso. Aguarde o processamento.', false);  
         this.exibirDialogConfirmarCsv = false;
         this.exibirDialogConfirmarCsvUltimoAcesso = false;
			})
			.catch(erro => {exibirMensagem(this, erro)});
    },
    /**
     * 
     */
    exibirConfirmarExportaCSV(tipo) {
      const email =  sessionStorage.getItem('EMAIL_CSV_EXPORTAR_CLIENTE');
      this.emailCSV = email ? email : '';
      if('GERAL' == tipo) {
        this.exibirDialogConfirmarCsv = true;
      } else { // 'ULTIMO_ACESSO'
        this.exibirDialogConfirmarCsvUltimoAcesso = true;
      }
    },
    /**
     * 
     */
    getStatus(status) {
      if(status == 1) {
        return 'Ativo'
      }
      if(status == 2) {
        return 'Bloqueado'
      }
      // 0
      return 'Inativo'
    },
    /**
     * 
     * @param cnpj 
     */
    formatarCNPJ(cnpj) {
      if (!cnpj) return '';
      return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    },
    /**
     * 
     * @param data 
     */
    formatarData(data) {
      if (!data) return '';
      const date = new Date(data);
      return date.toLocaleDateString('pt-BR');
    },
    /**
     * 
     * @param data 
     */
    formatarDataHora(data) {
      if (!data) return '';
      const date = new Date(data);
      return date.toLocaleString('pt-BR');
    },
    /**
     * 
     * @param data 
     */
    formatarDataAPI(data) {
      if (!data) return null;
      const d = new Date(data);
      return d.toISOString().split('T')[0];
    }
  },
  mounted() {
    this.empresaService = new EmpresaService();
    this.listarFiltros();
  },
};
</script>

<style scoped>
.p-field {
  margin-bottom: 1rem;
}
</style>